import { COMPONENT_TYPE } from 'common/constants';
import { SliderArrowDir } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';
import { sliderArrow } from '../slider-arrow/recipe';
import { sliderPagination } from '../slider-pagination/recipe';
import { sliderSlides } from '../slider-slides/recipe';

export const slider = ({
	language,
}: CreationContextFor<typeof COMPONENT_TYPE.SLIDER>): CreatedBuildingBlock<typeof COMPONENT_TYPE.SLIDER> =>
	createModel({
		type: COMPONENT_TYPE.SLIDER,
		editorProps: {
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {},
			other: {},
		},
		children: [
			sliderArrow({ direction: SliderArrowDir.PREV, language }),
			sliderArrow({ direction: SliderArrowDir.NEXT, language }),
			sliderPagination(),
			sliderSlides(),
		],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SLIDER>;
